import Index from "./index.vue";
import Vue from "vue";


const UploadProgress = (options) => {
    let instance;
    const UploadProgressConstructor = Vue.extend(Index);
    const initInstance = () => {
        instance = new UploadProgressConstructor();
        let el = instance.$mount().$el;
        document.body.appendChild(el);
    };
    if (!instance) {
        initInstance();
    }
    Object.assign(instance, options);
    instance.show();
    return instance;
};

export default {
    install: (Vue) => {
        Vue.prototype.$uploadProgress = UploadProgress;
    }
};
export {UploadProgress};
